module.exports = new __parcel__URL__("BrickFlicks.a262cd02.jpeg").toString();